import { CheckoutFlow } from '../flow/type'

export const getFlowPrefix = (flowName: CheckoutFlow): string => {
  switch (flowName) {
    case 'apple-paylater':
      return '/apple-paylater'
    default:
      return ''
  }
}
